<template>
	<el-main>
		<div class="colhead">
			<h2 class="header_h2">销售模块医学解释</h2>
		</div>
		<el-header>
			<el-button type="primary" style="margin:10px 5px 0px 10px;float: left;" @click="baonewAdd">手动添加</el-button>
			<el-input v-model="select_word" placeholder="销售模块名称过滤查找"
				style="display:inline-block;width:350px;float: left;"></el-input>
		<span style="float: left;">&emsp;选择企业：</span>
		<el-select style="float: left; width: 200px;  height:30px;" v-model="curcorpid" v-on:change="getAllData">
					<el-option v-for="item in CorpData" :label="item.corp_name" :value="item.corp_id" placeholder="请选择">
						{{ item.corp_name }}
					</el-option>
				</el-select>
				<el-button type="primary" style="float: left;margin:10px 5px 0px 10px;" @click="btnRefreshSaleModule"
				>自动同步销售模块</el-button>
		</el-header>
		<el-main>
			
			<el-table element-loading-text="拼命同步中"
				    element-loading-spinner="el-icon-loading"
				    element-loading-background="rgba(0, 0, 0, 0.8)"
				v-loading="fullscreenLoading"
			 border ref="multipleTable" tooltip-effect="dark" :data="data.slice((currentPage-1)*pagesize,currentPage*pagesize)">
				<!-- <el-table-column type="selection"></el-table-column> -->
				<el-table-column prop="SaleModuleName" label="销售模块" width="200px"></el-table-column>
				<el-table-column prop="FNote" label="医学解释" ></el-table-column>
				<el-table-column prop="EmpName" label="操作员" width="100px"></el-table-column>
				<el-table-column prop="EmpDate" label="操作时间" width="120px"></el-table-column>
				<el-table-column label="操作" width="200px" fixed="right">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.$index,scope.row)" icon="el-icon-bottom" type="text" size="small">查看</el-button>
						<el-button @click="handleEdit(scope.$index, scope.row)" icon="el-icon-edit" type="text" size="small">编辑</el-button>
						<!-- <el-button @click="handleDelete(scope.$index, scope.row)" icon="el-icon-circle-close" type="text" size="small">删除</el-button> -->
						<el-button type="text" @click="handleDelete(scope.$index, scope.row)" icon="el-icon-circle-close" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- </el-container> -->
			<el-footer style="margin-top:20px;">
				<template>
					<div class="block">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
						 :page-sizes="[5, 10, 20, 40]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="data.length"></el-pagination>
					</div>
				</template>
			</el-footer>
		</el-main>

		<!-- ----查看个人信息---- -->
		<el-dialog title="查看信息" :visible.sync="bao1look">
			<el-form :model="LookInfo" label-width="130px">
				<el-form-item label="销售模块">
					<el-input v-model="LookInfo.SaleModuleName"></el-input>
				</el-form-item>
				<el-form-item label="医学解释">
					<el-input type="textarea" v-model="LookInfo.FNote"></el-input>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 修改个人信息 -->
		<el-dialog title="修改信息" :visible.sync="bao1edit">
			<el-form :model="EditInfo" ref="EditInfo" label-width="100px">
				<el-form-item label="销售模块">
					<el-input v-model="EditInfo.SaleModuleName"></el-input>
				</el-form-item>
				<el-form-item label="医学解释">
					<el-input type="textarea" v-model="EditInfo.FNote"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1editSure">确定</el-button>
					<el-button @click.native="bao1edit = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
		<!-- ----新增个人信息---- -->
		<el-dialog title="新增医学解释信息" :visible.sync="bao1newadd">
			<el-form :model="AddInfo" ref="AddInfo" label-width="100px">
				<el-form-item label="销售模块编号">
					<el-input v-model="AddInfo.SaleModuleID"></el-input>
				</el-form-item>
				<el-form-item label="销售模块">
					<el-input v-model="AddInfo.SaleModuleName"></el-input>
				</el-form-item>
				<el-form-item label="医学解释">
					<el-input type="textarea" v-model="AddInfo.FNote"></el-input>
				</el-form-item>
				<!-- 按钮确定和取消 -->
				<el-form-item>
					<el-button type="primary" @click.native="bao1AddSure">确定</el-button>
					<el-button @click.native="bao1newadd = false">取消</el-button>
				</el-form-item>
			</el-form>

		</el-dialog>
	</el-main>
</template>



<script>
	import enums from '../../commontools/enums.js'
	import SaleModuleExplain from '../../apifunction/SalemoduleExplain.js'
	import corp from '../../apifunction/Corp.js'
	export default {
		data() {
			return {
				CorpData: [],
				curcorpid:'',
				MyData: [],
				currentPage: 1,
				pagesize: 10,
				fullscreenLoading: false,
				bao1look: false,
				bao1edit: false,
				bao1detele: false,
				bao1newadd: false,
				idx: null,
				deleteAll: [],
				del_list: [],
				//   通过姓名查询
				select_word: "",
				//   定义初始个人信息
				LookInfo: {
					SaleModuleID: '1',
					SaleModuleName: '内科',
					FNote: '内科',
					EmpID: '',
					EmpName: '',
					EmpDate: ''
				},
				EditInfo: {
					SaleModuleID: '1',
					SaleModuleName: '内科',
					FNote: '内科',
					EmpID: '',
					EmpName: '',
					EmpDate: '',
					CorpID: ''
				},
				AddInfo: {
					SaleModuleID: '',
					SaleModuleName: '',
					FNote: '',
					EmpID: '',
					EmpName: '',
					EmpDate: '',
					CorpID: ''
				}
			};
		},
		mounted() {
			this.getAllCorp();
		},
		methods: {
			getAllCorp() {
				corp.GetAllCorp()
					.then(res => {
						//alert(JSON.stringify(res.data))
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.CorpData = JSON.parse(ent.Data);
			
			
						} else
							this.$message.info(ent.Msg);
					})
			},
			
			//   得到所有的数据---------------
			getAllData: function() {
				//let user = JSON.parse(JSON.stringify(this.myglobal.userinfo));
				SaleModuleExplain.GetSaleModuleExplainAll(this.curcorpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						//alert(JSON.stringify(ent.Data))
						if (ent.Flag == 'success') {
							if(ent.Data!='null')
							this.MyData = JSON.parse(ent.Data)
							else
							this.MyData =[];
						} else
							this.$message.info(ent.Msg);
					})
				// this.MyData = enums.SalemoduleExplainData;
			},
			// 分页------------------------
			// 初始页currentPage、初始每页数据数pagesize和数据data
			handleSizeChange: function(size) {
				this.pagesize = size;
			},
			handleCurrentChange: function(currentPage) {
				this.currentPage = currentPage;
			},
			// 操作界面 ----------- 查看
			// 当点击查看时，让dialog显示,同时赋值数据
			handleClick(index, row) {
				this.bao1look = true;
				this.LookInfo = {
					SaleModuleID: row.SaleModuleID,
					SaleModuleName: row.SaleModuleName,
					FNote: row.FNote,
					EmpID: row.EmpID,
					EmpName: row.EmpName,
					EmpDate: row.EmpDate
				};
			},
			// 操作界面 ----------- 编辑-----通过改变数据并且驱动视图更新$set方法
			handleEdit(index, row) {
				this.idx = index;
				this.bao1edit = true;
				this.EditInfo = {
					SaleModuleID: row.SaleModuleID,
					SaleModuleName: row.SaleModuleName,
					FNote: row.FNote,
					EmpID: row.EmpID,
					EmpName: row.EmpName,
					EmpDate: row.EmpDate,
					CorpID: row.CorpID
				};
			},
			// 操作界面 ----------- 编辑 -------确定按钮
			bao1editSure() {
				this.EditInfo.EmpID = this.$myglobal.getUserInfo().id;
				this.EditInfo.EmpName = this.$myglobal.getUserInfo().username;
				this.EditInfo.EmpDate = this.CommonFun.GetNowDateTime();
				SaleModuleExplain.EditSaleModuleExplain(this.EditInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.MyData.splice(this.idx, 1, this.EditInfo)
							this.bao1edit = false;
							this.$message.success("修改成功");

						} else
							this.$message.info(ent.Msg);
					})

			},
			// 操作界面 ----------- 删除 -------
			// 	handleDelete(index, row) {
			// 	this.bao1detele = true;
			// 	this.idx = index;
			// }, 
			handleDelete(index, row) {
				this.$confirm('确定要删掉此信息?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(res => {
					var info = this.MyData[index];
					row.EmpID = this.$myglobal.getUserInfo().id;
					row.EmpName =  this.$myglobal.getUserInfo().username;
					row.EmpDate = this.CommonFun.GetNowDateTime();

					let fnote = row.FNote;
					info.FNote = '';
					SaleModuleExplain.EditSaleModuleExplain(row)
						.then(res => {
							let ent = JSON.parse(JSON.stringify(res.data))
							if (ent.Flag == 'success') {
								//this.MyData.splice(this.idx,1,this.EditInfo)
								//this.bao1detele = false;
								this.$message.warning("删除成功");

							} else {
								info.FNote = fnote;
								this.$message.info(ent.Msg);
							}
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			// 操作界面 ----------- 删除 -------确定按钮
			bao1DeteleSure() {

				// this.MyData.splice(this.idx, 1);
				// this.bao1detele = false;
				// this.$message.warning("删除成功");
			},
			// 新增按钮-----
			baonewAdd() {
				if(this.curcorpid=='')
				{
					this.$message.info("请选择企业！");
					return;
				}
				this.bao1newadd = true;
				this.AddInfo= {
					SaleModuleID: '',
					SaleModuleName: '',
					FNote: '',
					EmpID: '',
					EmpName: '',
					EmpDate: '',
					CorpID: this.curcorpid
				}
			},
			// 新增按钮----- 新增 ----确定按钮
			bao1AddSure() {
				//this.$refs.AddInfo 这个数据上有一个validate方法,这个方法可以判断数据是否存在
				
				this.AddInfo.EmpID =  this.$myglobal.getUserInfo().id;
				this.AddInfo.EmpName =  this.$myglobal.getUserInfo().username;
				this.AddInfo.EmpDate = this.CommonFun.GetNowDate();
				
				SaleModuleExplain.AddSaleModuleExplain(this.AddInfo)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.MyData.unshift(this.AddInfo);
							this.bao1newadd = false;
							this.$message.success("新增成功");

						} else
							this.$message.info(ent.Msg);
					})
			},
			btnRefreshSaleModule() {
				this.fullscreenLoading = true;
				SaleModuleExplain.RefreshSaleModuleExplain(this.curcorpid)
					.then(res => {
						let ent = JSON.parse(JSON.stringify(res.data))
						if (ent.Flag == 'success') {
							this.$message.success("同步完成！");

						} else
							this.$message.info(ent.Msg);
						this.fullscreenLoading = false;
					})
					.catch(ex => {
						this.fullscreenLoading = false;
					})

			},
			// 当用户手动勾选数据行的 Checkbox 时触发的事件, 将所有的勾选的数据集中到一个数组中
			select(selection, row) {
				this.deleteAll = selection;
			},
			// 批量删除-----all
			// baodeleteAll() {
			// 	// console.log(this.deleteAll);
			// 	if (this.deleteAll.length) {
			// 		this.del_list = this.del_list.concat(this.deleteAll);
			// 		this.deleteAll = [];
			// 		this.$message.success("删除成功");
			// 	} else {
			// 		this.$message.warning("请选择删除目标");
			// 	}
			// }
		},
		computed: {
			data() {
				return this.MyData.filter(item => {
					// return item;
					let is_del = false;
					for (let i = 0; i < this.del_list.length; i++) {
						if (item.SaleModuleName === this.del_list[i].SaleModuleName) {
							is_del = true;
							break;
						}
					}
					if (!is_del) {
						if (
							item.SaleModuleName.indexOf(this.select_word) > -1
						) {
							return item;
						}
					}
				});
			}
		}
	};
</script>


<style scoped>
	.colhead {
		padding-bottom: 10px;
		border-bottom: 1px solid #ccc;
	}

	.header_h2 {
		color: #333;
		background-color: #f5f5f5;
		border-color: #ddd;
		font-size: 20px;
		text-align: left;
		line-height: 1.7;
		text-align: center;
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
	}
</style>
